import React from 'react';
import { Form as FormikForm } from 'formik';
import { Box, Button } from '@material-ui/core';

interface InlineFormWrapperProps {
    submitText: React.ReactText;
    children: React.ReactNode[] | React.ReactNode;
    isSubmitting: boolean;
}

const InlineFormWrapper = ({ submitText, children, isSubmitting }: InlineFormWrapperProps) => (
    <FormikForm autoComplete="off">
        <Box display="flex" alignItems='baseline'>
            {children}
            <Button
                disabled={isSubmitting}
                type="submit"
                variant="contained"
                color="primary"
            >
                {submitText}
            </Button>
        </Box>
    </FormikForm>
);

export default InlineFormWrapper;
